import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  
  getItem(name: string): any {
    return localStorage.getItem(name);
  }

  setItem(name: string, token: any) {
    localStorage.setItem(name, token);
  }
}
